import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalSiteSettingsState,
  selectSiteSettings,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { PipelinePage } from '../components/PipelinePage'
import {
  actionCreators,
  IPipelineState,
  selectError,
  selectIsDeleting,
  selectIsLoading,
  selectPermissions,
  selectPipeline,
  selectProfit,
  selectShowConfirmDelete,
} from '../modules/pipeline'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IPipelineState & ICurrentUserState & IGlobalSiteSettingsState
    >({
      error: selectError(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      permissions: selectPermissions(),
      pipeline: selectPipeline(),
      profit: selectProfit(),
      showConfirmDelete: selectShowConfirmDelete(),
      siteSettings: selectSiteSettings(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(PipelinePage),
)
